import React from "react";
import { Stack } from "@mui/material";
import { useSelector } from "react-redux";
import {Bot, Direction, GridType, RangeStart} from "../../../_app/types";
import {Order} from "../../../class/Order";
import {RootState} from "../../../store/store";
import CalcGrids from "../../../components/AddingBot/CalcGrids";
import {ButtonStyled} from "../../../_components/ButtonStyled";
import Filters from "../../../components/ui/icons/Filters";
import FuturesBotCalcGrids from "./FuturesBotCalcGrids";

interface Props {
  gridsAmount: number;
  bot: Bot;
  onChangeGridsAmount: (value: number) => void;
  gridDirection: Direction;
  gridType: GridType;
  onChangeGridType: (value: GridType) => void;
  priceStep: number;
  onChangePriceStep: (value: number) => void;
  orderList: Order[];
  onChangeInvestmentInQuote: (investmentInQuote: number) => void;
  onChangeInvestmentInBase: (investmentInBase: number) => void;
  onChangeOrderList: (list: Order[]) => void;
  priceStepQuery: number;
  orderStep: number;
  rangeStartMode: RangeStart;
  showAdvanced: (value: boolean) => void;
}

const FuturesBotGridSettings = ({
  onChangeGridType,
  gridType,
  gridsAmount,
  onChangeGridsAmount,
  gridDirection,
  priceStep,
  onChangePriceStep,
  bot,
  orderList,
  onChangeInvestmentInQuote,
  onChangeInvestmentInBase,
  onChangeOrderList,
  priceStepQuery,
  orderStep,
  rangeStartMode,
  showAdvanced,
}: Props) => {
  const CustomGridMode = useSelector((state: RootState) => state.customGridMode);

  return (
    <>
      <Stack direction={"column"} spacing={1} sx={{ paddingTop: 2 }}>
        <FuturesBotCalcGrids
          gridDirection={gridDirection}
          onChangeGridsAmount={onChangeGridsAmount}
          gridsAmount={CustomGridMode ? bot.customGridSettings.length : gridsAmount}
          gridType={gridType}
          onChangeGridType={onChangeGridType}
          priceStep={priceStep}
          onChangePriceStep={onChangePriceStep}
          bot={bot}
          orderList={orderList}
          onChangeInvestmentInBase={onChangeInvestmentInBase}
          onChangeInvestmentInQuote={onChangeInvestmentInQuote}
          onChangeOrderList={onChangeOrderList}
          priceStepQuery={priceStepQuery}
          orderStep={orderStep}
          rangeStartMode={rangeStartMode}
        />
        <ButtonStyled
          onClick={() => showAdvanced(true)}
          style={{ display: "flex", justifyContent: "space-between", padding: "8px 16px" }}
          fullWidth={true}
          color={"secondary"}
          variant="contained"
          endIcon={<Filters />}
        >
          Additional settings (optional)
        </ButtonStyled>
      </Stack>
    </>
  );
};

export default FuturesBotGridSettings;
